import { StyleSheet } from 'aphrodite';

const htmlNewsletterComposerSubjectHeaderHeight = 110;

export const styleSheet = StyleSheet.create({
	htmlNewsletterComposer: {
		width: '100%',
	},
	htmlNewsletterComposerContent: {
		height: `calc(100% - ${htmlNewsletterComposerSubjectHeaderHeight}px)`,
		width: '100%',
	},
	htmlNewsletterComposerContentForAutomation: {
		height: '100%',
		width: '100%',
	},
	htmlNewsletterComposerContentWithoutSubject: {
		height: '100%',
	},
	htmlNewsletterComposerEditButton: {
		marginLeft: 'auto',
	},
	htmlNewsletterComposerSubjectHeader: {
		borderBottom: '1px solid #CAE0EC',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: htmlNewsletterComposerSubjectHeaderHeight,
		justifyContent: 'space-between',
		padding: 20,
	},
});
